import {UpmEntityType} from '@hconnect/common/types'
import {dataTestId, Loader} from '@hconnect/uikit'
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Stack,
  Typography
} from '@mui/material'
import React from 'react'
import {useTranslation} from 'react-i18next'

import {useAssetsQuery} from '../../common/hooks'
import {useMaterialStorageListQuery} from '../../storages/hooks'
import {useDeleteEquipment} from '../hooks/upmEntityConfig/useDeleteEquipment'
import {useItemDetails} from '../providers'

import {useGetSignals} from '@settings/modules/upm/components/SignalList/api/useGetSignals'

export const DeleteEquipmentPopup = () => {
  const {setEquipmentToDelete, equipmentToDelete} = useItemDetails()

  const {data: assets, isLoading} = useAssetsQuery()
  const {data: materialStorages} = useMaterialStorageListQuery()
  const {data: signals, isLoading: isLoadingSignals} = useGetSignals({
    entityType: UpmEntityType.Equipment,
    entityId: equipmentToDelete?.upmId ?? ''
  })
  const assetsOrSignalsAttached =
    assets?.some((a) => a.upmId === equipmentToDelete?.upmId) ||
    materialStorages?.some((s) => s.upmId === equipmentToDelete?.upmId) ||
    (signals?.length && signals.length > 0)

  const SAPPrefixes = ['PR0', 'PRA', 'PRS']
  const isSapEquipment = SAPPrefixes.some((source) => equipmentToDelete?.source?.includes(source))
  const isDeletedInSource = equipmentToDelete?.isDeletedInSource
  const equipmentText = equipmentToDelete?.text

  const handleClose = () => {
    setEquipmentToDelete()
  }

  const {mutate: deleteEquipment} = useDeleteEquipment()

  const {t} = useTranslation()

  const handleDeleteEquipment = () => {
    if (equipmentToDelete) {
      deleteEquipment(equipmentToDelete.upmId, {
        onSuccess: () => setEquipmentToDelete()
      })
    }
  }

  if (isLoading || isLoadingSignals) {
    return <Loader />
  }

  return (
    <Dialog open onClose={handleClose} maxWidth="sm" fullWidth>
      <DialogTitle>{t('plantSetup.departmentConfig.deleteEquipment')}</DialogTitle>
      <DialogContent>
        <Stack gap={2}>
          {!!assetsOrSignalsAttached && (
            <Typography>
              {t('plantSetup.departmentConfig.assetsOrStoragesMappedEquipment')}
            </Typography>
          )}
          {!isDeletedInSource && isSapEquipment ? (
            <Typography fontWeight={'bold'}>
              {t('plantSetup.departmentConfig.equipmentImportedFromSAP')}
            </Typography>
          ) : assetsOrSignalsAttached ? null : (
            <Typography>
              {t('plantSetup.departmentConfig.deleteEquipmentConfirmation', {equipmentText})}
            </Typography>
          )}
        </Stack>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} color="secondary">
          {isDeletedInSource ? t('common.cancel') : t('common.close')}
        </Button>
        {(isSapEquipment && !isDeletedInSource) || assetsOrSignalsAttached ? null : (
          <Button
            {...dataTestId('delete-equipment-btn')}
            type="submit"
            variant="contained"
            color="error"
            onClick={handleDeleteEquipment}
          >
            {t('common.remove')}
          </Button>
        )}
      </DialogActions>
    </Dialog>
  )
}
